import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  settingsDoc;
  settingsObs;
  settings;
  draftStartDateDate;
  draftStartDateHour;
  draftStartDateMinute;
  phaseOneEndDateDate;
  phaseOneEndDateHour;
  phaseOneEndDateMinute;
  phaseTwoEndDateDate;
  phaseTwoEndDateHour;
  phaseTwoEndDateMinute;
  draftEndDateDate;
  draftEndDateHour;
  draftEndDateMinute;

  playersCol;
  players;
  selectedPlayerId;
  playerToAdd;
  constructor(private afs: AngularFirestore) { }

  ngOnInit() {
    const that = this;
    this.settingsDoc = this.afs.doc('settings/' + 'yiEAeF7M7TGmk99TY1GC');
    this.settingsObs = this.settingsDoc.valueChanges();
    this.settings = this.settingsObs.subscribe(settings => {
      that.settings = settings;
      that.draftStartDateDate = new Date(new Date(that.settings.startDateTime).setHours(0, 0, 0, 0));
      that.draftStartDateHour = new Date(that.settings.startDateTime).getHours();
      that.draftStartDateMinute = new Date(that.settings.startDateTime).getMinutes();
      that.phaseOneEndDateDate = new Date(new Date(that.settings.phaseOneEndDateTime).setHours(0, 0, 0, 0));
      that.phaseOneEndDateHour = new Date(that.settings.phaseOneEndDateTime).getHours();
      that.phaseOneEndDateMinute = new Date(that.settings.phaseOneEndDateTime).getMinutes();
      that.phaseTwoEndDateDate = new Date(new Date(that.settings.phaseTwoEndDateTime).setHours(0, 0, 0, 0));
      that.phaseTwoEndDateHour = new Date(that.settings.phaseTwoEndDateTime).getHours();
      that.phaseTwoEndDateMinute = new Date(that.settings.phaseTwoEndDateTime).getMinutes();
      that.draftEndDateDate = new Date(new Date(that.settings.draftEndDateTime).setHours(0, 0, 0, 0));
      that.draftEndDateHour = new Date(that.settings.draftEndDateTime).getHours();
      that.draftEndDateMinute = new Date(that.settings.draftEndDateTime).getMinutes();
    });
    this.playersCol = this.afs.collection('players');
    this.players = this.playersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
  }

save() {
  const startDate = new Date(this.draftStartDateDate);
  startDate.setHours(this.draftStartDateHour);
  startDate.setMinutes(this.draftStartDateMinute);
  this.settings.startDateTime = startDate.getTime();

  const phaseOneEndDate = new Date(this.phaseOneEndDateDate);
  phaseOneEndDate.setHours(this.phaseOneEndDateHour);
  phaseOneEndDate.setMinutes(this.phaseOneEndDateMinute);
  this.settings.phaseOneEndDateTime = phaseOneEndDate.getTime();

  const phaseTwoEndDate = new Date(this.phaseTwoEndDateDate);
  phaseTwoEndDate.setHours(this.phaseTwoEndDateHour);
  phaseTwoEndDate.setMinutes(this.phaseTwoEndDateMinute);
  this.settings.phaseTwoEndDateTime = phaseTwoEndDate.getTime();

  const draftEndDate = new Date(this.draftEndDateDate);
  draftEndDate.setHours(this.draftEndDateHour);
  draftEndDate.setMinutes(this.draftEndDateMinute);
  this.settings.draftEndDateTime = draftEndDate.getTime();
  this.settingsDoc.update(this.settings);
}

addPlayer() {
  this.playersCol.add({name: this.playerToAdd, bids: []});
  this.playerToAdd = null;
}

deletePlayer() {
  this.playersCol.doc(this.selectedPlayerId).delete();
}

}



// WEBPACK FOOTER //
// ./src/app/components/settings/settings.component.ts